import Text from './Text'
import Header from './Header'
import Title from './Title'

export default Text
export { 
    Header, 
    Title 
}